import React from 'react';
import moment from 'moment';

import { nivelProbabilidade } from '../rules/regraContexto';

/**
 * Tempo de permanência exibido na coluna Entrada.
 */
const formatarTempoEntrada = (minutos) => {
  const valor = Number(minutos) || 0;
  if (valor <= 60) {
    return valor + (valor === 1 ? ' min' : ' mins');
  }
  if (valor <= 1440) {
    const horas = Math.trunc(valor / 60);
    return horas + (horas === 1 ? ' hora' : ' horas');
  }
  const dias = Math.trunc(valor / 1440);
  return dias + (dias === 1 ? ' dia' : ' dias');
};

/** Duração no formato "Xh:mm" dos cards de indicadores. Ex.: 70 -> "1h10". */
const formatarDuracao = (minutos) => {
  const valor = Math.max(Math.round(Number(minutos) || 0), 0);
  const horas = Math.trunc(valor / 60);
  const resto = valor % 60;
  return horas + 'h' + String(resto).padStart(2, '0');
};

/** Sobrenome + inicial ("PEREIRA, R"). Amaral Carvalho exibe o nome completo. */
const formatarNomePaciente = (nomePaciente, locationName) => {
  const nome = nomePaciente ?? '';
  if (locationName === 'Amaral Carvalho') {
    return nome;
  }
  const partes = nome.trim().split(' ').filter(Boolean);
  if (partes.length <= 1) {
    return nome;
  }
  return partes.slice(-1).join(' ') + ', ' + partes[0].slice(0, 1);
};

const formatarNascimento = (nascimento) => (
  nascimento ? moment(nascimento).format('DD/MM/YYYY') : ''
);

/** Setor e especialidade vêm em caixa alta do banco: "EMERGENCIA ADULTO" -> "Emergencia adulto". */
const formatarDescricao = (descricao) => {
  if (!descricao) return '';
  const texto = String(descricao).toLowerCase();
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

/** Largura da barra que acompanha o percentual, limitada a 0-100%. */
const larguraProbabilidade = (previsaointernacao) => (
  Math.min(Math.max(Number(previsaointernacao) || 0, 0), 100) + '%'
);

/** Enquadra o contexto nos dois grupos previstos na demanda: <24h e <72h. */
const LIMITE_24H = 24;
const faixaContexto = (contexto) => ((Number(contexto.horas) || 0) <= LIMITE_24H ? 24 : 72);

/**
 * "Reprocura 24h · Cardiologia" | "Readmissão 72h · 67% · Neurologia".
 * Só a probabilidade muda de cor dentro do badge.
 */
const formatarContexto = (contexto) => {
  const probabilidade = contexto.probabilidade ?? null;
  const SEPARADOR = ' · ';

  return (
    <>
      {contexto.tipo + ' ' + faixaContexto(contexto) + 'h'}
      {probabilidade !== null && (
        <>
          {SEPARADOR}
          <span className={'badgeContexto-probabilidade nivel-' + nivelProbabilidade(probabilidade)}>
            {Math.round(probabilidade) + '%'}
          </span>
        </>
      )}
      {contexto.especialidade && SEPARADOR + formatarDescricao(contexto.especialidade)}
    </>
  );
};

const FormatHelpers = {
  formatarTempoEntrada,
  formatarDuracao,
  formatarNomePaciente,
  formatarNascimento,
  formatarDescricao,
  larguraProbabilidade,
  formatarContexto,
  faixaContexto,
};

export default FormatHelpers;
